import { Link } from "react-router-dom";
import { UserManager } from "../components/Admin/UserManager";
import { PlanUploader } from "../components/Admin/PlanUploader";

export function AdminPage() {
  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-6 p-4">
      <header className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-slate-100">Administración</h1>
        <Link
          to="/plans"
          className="rounded-md border border-slate-700 px-3 py-1 text-xs text-slate-300 hover:bg-slate-800"
        >
          Volver a planos
        </Link>
      </header>

      <PlanUploader />
      <UserManager />
    </div>
  );
}
